export default __webpack_public_path__ + "static/media/email_grey.87f30e89.png";